"use client";

import { useState, useEffect, useRef } from "react";
import PN from "persian-number";
import { Button } from "@nextui-org/react";
import { IoClose } from "react-icons/io5";

const OtpInput = ({ length, error, apiCallback, watchValue }) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [inputLoading, setInputLoading] = useState(false);
  const firstInputRef = useRef(null);

  useEffect(() => {
    // Focus on the first input field when the component mounts
    if (firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [watchValue]);

  useEffect(() => {
    if (error) {
      setInputLoading(false);
    }
  }, [error]);

  const handleChange = (element, index) => {
    const _val = PN.convertPeToEn(element.value);
    if (isNaN(_val)) return;

    const newOtp = [...otp];
    newOtp[index] = _val;

    setOtp(newOtp);

    // Focus next input
    if (element.value && element.nextSibling) {
      element.nextSibling.focus();
    }

    // Trigger the onChange callback

    setTimeout(() => {
      if (newOtp.every((digit) => digit !== "")) {
        setInputLoading(true);
        apiCallback(newOtp.join(""));
      }
    }, 0);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && e.target.previousSibling) {
        e.target.previousSibling.focus();
      }
    }
  };

  return (
    <div className="flex items-center gap-1 md:gap-3 md:ml-5">
      <Button
        isIconOnly
        radius="full"
        onClick={() => {
          setOtp(new Array(length).fill(""));
          setInputLoading(false);
        }}
      >
        <IoClose size={25} />
      </Button>
      <div className="flex flex-row-reverse space-x-reverse space-x-2">
        {otp?.map((data, index) => {
          return (
            <input
              className={`w-8 ssm:w-11 md:w-14 mr-2 text-base md:text-xl h-12 md:h-16 text-[var(--content-inverted-primary)] md:text-[var(--surface-inverted-primary)] bg-[var(--surface-inverted-primary)] md:bg-[var(--surface-inverted-tertiary)] rounded-md text-center focus:outline-none focus:border-2 focus:border-[var(--border-primary)]
            ${error
                  ? "border-3 border-solid border-primary focus:border-3 focus:border-primary"
                  : ""
                }
            ${inputLoading ? "opacity-60" : ""}
            `}
              type="text"
              inputMode="numeric"
              name="otp"
              maxLength="1"
              disabled={inputLoading}
              key={index}
              value={data}
              onChange={(e) => handleChange(e.target, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onFocus={(e) => e.target.select()}
              ref={index === 0 ? firstInputRef : null}
            />
          );
        })}
      </div>
    </div>
  );
};

export default OtpInput;
